import * as React from "react";
import { useMemo } from "react";
import { isNil } from "ramda";

import { NavigateButton } from "affinityUI/elements/button";
import { ButtonGroup } from "affinityUI/form/components";
import { Layout } from "affinityUI/structures/layout";
import { Users } from "components/views/users";
import { exhUserToUsersEntry } from "lib/extrahorizon/converters/users";
import { useExhUsers } from "lib/extrahorizon/hooks";

import { UsersEntryType } from "../../../views/users/types";

export const UsersPage: React.FC = () => {
  const { users: exhUsers, isLoading } = useExhUsers();
  const users = useMemo<UsersEntryType[]>(() => exhUsers.map(exhUserToUsersEntry), [exhUsers]);

  return (
    <Layout
      title="Users"
      loading={isLoading}
      actions={
        <ButtonGroup>
          <span style={{ display: "none" }}>
            <NavigateButton id="add_user" to="add">
              Add user
            </NavigateButton>
          </span>
        </ButtonGroup>
      }
    >
      {!isNil(users) && <Users users={users} />}
    </Layout>
  );
};
